import { FundingProfileFieldValues } from "@components/utils/AddFundingProfileForm/types";
import { Currency } from "@types";
import { parseUpiId } from "@utils/bank-parsing";
import { CreateFundingProfileRequest, MemberBankFundingType, standardizePhoneNumber } from "kz-ui-sdk";

export function mapBankFundingDetails({
  currency,
  data,
  phonePrefix,
}: {
  currency: Currency;
  data: Partial<FundingProfileFieldValues>;
  phonePrefix: string;
}): Partial<Pick<CreateFundingProfileRequest, "info" | "accNo">> {
  const result: Partial<Pick<CreateFundingProfileRequest, "info" | "accNo">> = {
    accNo: data?.accountNo?.trim(),
  };

  switch (currency) {
    case Currency.INR: {
      if (data.bankType === MemberBankFundingType.UPI) {
        result.info = { bankType: MemberBankFundingType.UPI };
        const upiBank = parseUpiId(data.accountNo);
        if (upiBank) {
          result.accNo = upiBank.accountNumber || "";
        }
      } else if (data.bankType === MemberBankFundingType.IFSC) {
        const info: any = { bankType: data.bankType, ifsc: data.ifsc };
        result.info = info;
      }
      break;
    }

    case Currency.BRL: {
      const subType = data.pixKeyType;
      if (subType) {
        result.info = { bankType: data.bankType, subType };
        if (subType === "phone") {
          result.accNo = standardizePhoneNumber(data.accountNo || "", phonePrefix);
        }
      }
      break;
    }

    case Currency.MXN: {
      result.info = { bankType: MemberBankFundingType.CLABE } as any;
      break;
    }

    case Currency.PEN: {
      const penInfo: any = {};

      if (data.bankType === MemberBankFundingType.CCI) {
        penInfo.bankType = MemberBankFundingType.CCI;
        penInfo.cci = data.cci?.trim();
      }

      if (data.cardType) {
        penInfo.cardType = data.cardType;
      }

      if (Object.keys(penInfo).length > 0) {
        result.info = penInfo;
      }
      break;
    }

    case Currency.COP: {
      const copInfo: any = {};

      if (data.cardType) {
        copInfo.cardType = data.cardType;
      }

      if (Object.keys(copInfo).length > 0) {
        result.info = copInfo;
      }
      break;
    }

    default:
      break;
  }

  return result;
}
